import React from 'react';
import { Navigate } from 'react-router-dom';
import RootLayout from '../layouts/RootLayout';
import AppLayout from '../layouts/AppLayout';

// Pages
import DashboardPage from '../pages/DashboardPage';
import SocialsPage from '../pages/SocialsPage';
import GalleryPage from '../pages/GalleryPage';
import ProfilePage from '../pages/ProfilePage';
import TimeSlotsPage from '../pages/TimeSlotsPage';
import OnboardingPage from '../pages/OnboardingPage';
import NotFoundPage from '../pages/NotFoundPage';
import ExternalRedirect from '../components/ExternalRedirect';
import { getRedirectUrl } from '../utils/helpers';

const redirectUriForSettings = getRedirectUrl('/dashboard/settings');

export const routes = [
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Navigate to='/dashboard' replace />,
      },
      {
        path: 'onboarding',
        element: <OnboardingPage />,
      },
      {
        path: '/',
        element: <AppLayout />,
        children: [
          {
            path: 'dashboard',
            element: <DashboardPage />,
          },
          {
            path: 'socials',
            element: <SocialsPage />,
          },
          {
            path: 'gallery',
            element: <GalleryPage />,
          },
          {
            path: 'profile',
            element: <ProfilePage />,
          },
          {
            path: 'schedule',
            element: <TimeSlotsPage />,
          },
          {
            path: 'settings',
            element: <ExternalRedirect url={redirectUriForSettings} />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];
